import React, { Fragment, useEffect, useState } from "react"; 
import { getLoggedInUserGUID, getTimeZoneID, getTimeZoneText, GetAssessmentName } from '../../../../src/web/components/utils';
import { useNavigate, useLocation } from "react-router-dom";
import logoWhite from '../../../../src/web/assets/img/logo_white.png';
import barIcon from '../../../../src/web/assets/img/icons/bar-icon.svg';
import noteIcon from '../../../../src/web/assets/img/icons/note-icon-01.svg';
import settingIcon from '../../../../src/web/assets/img/icons/setting-icon-01.svg';
import notificationIcon from '../../../../src/web/assets/img/icons/note-icon-02.svg';
import dummyUser from '../../../../src/web/assets/img/user-06.jpg';
import { getLoggedInUser, checkIsAdminPanel, checkIsPatientPanel, checkIsCompanyPanel } from '../../../../src/web/components/utils';
import { checkPath, LoginType } from "../../../../src/utils";
import $ from 'jquery';

interface RouteProps { }
const Header: React.FC<RouteProps> = React.memo((): JSX.Element => {
    let navigate = useNavigate();
    const { pathname, search } = useLocation();
    const query = new URLSearchParams(search);
    const hideSidebar = query.get('v');
    const [userName, setUserName] = useState<string>();
    const [userRole, setUserRole] = useState<string>();

    useEffect(() => {
        const uData = getLoggedInUser();
        
        let role = "Doctor";
        if (uData?.UserTypeID === LoginType.Therapist) { role = "Physical Therapist"; }
        else if (uData?.UserTypeID === LoginType.Patient) { role = "Patient"; }
        else if (uData?.UserTypeID === LoginType.Admin) { role = "Admin"; }
        else if (uData?.UserTypeID === LoginType.CompanyAdmin) {
            role = "Company Admin";
            uData.FirstName = uData?.Email;
            uData.LastName = '';
        }
        setUserName(`${uData?.FirstName} ${uData?.LastName}`);
        setUserRole(role);
    }, []);

    const togglSidebar = () => {
        if ($('body').hasClass('mini-sidebar')) {
            $('body').removeClass('mini-sidebar');
            $('.subdrop + ul').slideDown();
        } else {
            $('body').addClass('mini-sidebar');
            $('.subdrop + ul').slideUp();
        }
        //mouseover
        $(document).on('mouseover', function (e) {
            e.stopPropagation();
            if ($('body').hasClass('mini-sidebar') && $('#toggle_btn').is(':visible')) {
                var targ = $(e.target).closest('.sidebar').length;
                if (targ) {
                    $('body').addClass('expand-menu');
                    $('.subdrop + ul').slideDown();
                } else {
                    $('body').removeClass('expand-menu');
                    $('.subdrop + ul').slideUp();
                }
                return false;
            }
        });
    }

    const toggleNotification = () => {
        // Variables declarations
        var $wrapper = $('.main-wrapper');
        // Mobile Menu
        // $(document).on('click', '#open_msg_box', function () {
        $wrapper.toggleClass('open-msg-box');
        return false;
        // });
    }

    const logoutAdmin = () => {
        localStorage.clear();
        navigate('/');
        // navigate('/admin');
    }

    return (
        <div className="xmain-wrapper">
            <div className="header">
                {/* <h6>ADMIN--{checkIsAdminPanel(pathname) ? "TRUE" : "FALSE"}</h6>
                <h6>PATIENT--{checkIsPatientPanel(pathname) ? "TRUE" : "FALSE"}</h6> */}
                <div className="header-left">
                    <a onClick={() => { navigate(`${checkIsAdminPanel(pathname) ? '/admin/admindashboard' : checkIsPatientPanel(pathname) ? '/patient/patientdashboard' : checkIsCompanyPanel(pathname) ? '/companyadmin/dashboard' : '/dashboard'}`) }} className="logo">
                        <img src={logoWhite} width="150px" alt="" />
                    </a>
                </div>
                {
                    !checkPath(pathname, 'logoutsave') && !checkPath(pathname, 'signupthanks') && !checkPath(pathname, 'registerDetails') &&
                    <Fragment>
                        {
                            (
                                !checkIsAdminPanel(pathname) &&
                                !checkIsPatientPanel(pathname) &&
                                !checkIsCompanyPanel(pathname) && 
                                hideSidebar === 'true'
                            ) &&
                            <a id="toggle_btn" onClick={() => togglSidebar()} href="javascript:void(0);">
                                <img src={barIcon} alt="" />
                            </a>
                        }

                        <a id="mobile_btn" className="mobile_btn float-start" href="#sidebar"><img src="assets/img/icons/bar-icon.svg" alt="" /></a>
                        <ul className="nav user-menu float-end">
                            {/* <li onClick={() => toggleNotification()} className="nav-item dropdown d-none d-sm-block">
                                <a href="javascript:void(0);" id="open_msg_box" className="hasnotifications nav-link">
                                    <img src={notificationIcon} alt="" />
                                    <span className="pulse"></span></a>
                            </li> */}
                            <li className="nav-item dropdown d-none d-sm-block">
                                {/* <a href="#" className="dropdown-toggle nav-link" data-bs-toggle="dropdown">
                                    <img src={noteIcon} alt="" />
                                    <span className="pulse"></span>
                                </a> */}
                                {/* <div className="dropdown-menu notifications xshow">
                                    <div className="topnav-dropdown-header">
                                        <span>Notifications</span>
                                    </div>
                                    <div className="drop-scroll">
                                        <ul className="notification-list">
                                            <li className="notification-message">
                                                <a href="activities.html">
                                                    <div className="media">
                                                        <span className="avatar">
                                                            <img alt="John Doe" src="assets/img/user.jpg" className="img-fluid" />
                                                        </span>
                                                        <div className="media-body">
                                                            <p className="noti-details"><span className="noti-title">Dr. John Doe</span> added new task <span className="noti-title">Patient appointment booking</span></p>
                                                            <p className="noti-time"><span className="notification-time">4 mins ago</span></p>
                                                        </div>
                                                    </div>
                                                </a>
                                            </li>
                                            <li className="notification-message">
                                                <a href="activities.html">
                                                    <div className="media">
                                                        <span className="avatar">V</span>
                                                        <div className="media-body">
                                                            <p className="noti-details"><span className="noti-title">Tarah Shropshire</span> changed the task name <span className="noti-title">Appointment booking with payment gateway</span></p>
                                                            <p className="noti-time"><span className="notification-time">6 mins ago</span></p>
                                                        </div>
                                                    </div>
                                                </a>
                                            </li>
                                            <li className="notification-message">
                                                <a href="activities.html">
                                                    <div className="media">
                                                        <span className="avatar">L</span>
                                                        <div className="media-body">
                                                            <p className="noti-details"><span className="noti-title">Misty Tison</span> added <span className="noti-title">Domenic Houston</span> and <span className="noti-title">Claire Mapes</span> to project <span className="noti-title">Doctor available module</span></p>
                                                            <p className="noti-time"><span className="notification-time">8 mins ago</span></p>
                                                        </div>
                                                    </div>
                                                </a>
                                            </li>
                                            <li className="notification-message">
                                                <a href="activities.html">
                                                    <div className="media">
                                                        <span className="avatar">G</span>
                                                        <div className="media-body">
                                                            <p className="noti-details"><span className="noti-title">Rolland Webber</span> completed task <span className="noti-title">Patient and Doctor video conferencing</span></p>
                                                            <p className="noti-time"><span className="notification-time">12 mins ago</span></p>
                                                        </div>
                                                    </div>
                                                </a>
                                            </li>
                                            <li className="notification-message">
                                                <a href="activities.html">
                                                    <div className="media">
                                                        <span className="avatar">V</span>
                                                        <div className="media-body">
                                                            <p className="noti-details"><span className="noti-title">Bernardo Galaviz</span> added new task <span className="noti-title">Private chat module</span></p>
                                                            <p className="noti-time"><span className="notification-time">2 days ago</span></p>
                                                        </div>
                                                    </div>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="topnav-dropdown-footer">
                                        <a href="#">View all Notifications</a>
                                    </div>
                                </div> */}
                            </li>
                            <li className="nav-item dropdown has-arrow user-profile-list">
                                <a href="#" className="dropdown-toggle nav-link user-link" data-bs-toggle="dropdown">
                                    <div className="user-names">
                                        <h5>{userName}</h5>
                                        <span>{userRole}</span>
                                    </div>
                                    <span className="user-img">
                                        <img src={dummyUser} alt="Admin" />
                                    </span>
                                </a>
                                {/* <div className="xdropdown-menu">
                                    <a className="dropdown-item" href="#">My Profile</a>
                                    <a onClick={() => logoutAdmin()} className="dropdown-item">Logout</a>
                                </div> */}
                            </li>
                            <li className="cursor-pointer nav-item dropdown d-none d-sm-block">
                                <a onClick={() => logoutAdmin()} className="dropdown-item">Logout</a>
                            </li>
                            {/* <li className="nav-item dropdown d-none d-sm-block">
                                <a href="javascript:void(0);" id="open_msg_box" className="hasnotifications nav-link">
                                    <img src={settingIcon} alt="" />
                                </a>
                            </li> */}
                        </ul>
                        {/* <div className="dropdown mobile-user-menu float-end">
                            <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><i className="fa-solid fa-ellipsis-vertical"></i></a>
                            <div className="dropdown-menu dropdown-menu-end">
                                <a className="dropdown-item" href="profile.html">My Profile</a>
                                <a className="dropdown-item" href="index.html">Logout</a>
                            </div>
                        </div> */}
                    </Fragment>
                }
            </div>
        </div>
    );
});

export default Header;